import React, { useRef, useState } from 'react';
import { RejectCandidateStageModal } from '../../RejectCandidate';
import { User } from '../../../../../entities/User';
import { Alert, AlertObject, AlertType } from '../../../../../components/Alert';

interface PropTypes {
  applicationId: number;
  candidateName: string;
  jobName?: string;
  isOpen: boolean;
  sendEmailEnabled: boolean;
  user: User;
  onClose: (sendEmail: boolean) => void;
  onSuccess?: (applicationId: number) => void;
  reloadApplication?: () => void;
}

export function RejectCandidateModal(props: PropTypes) {
  const [alertObject, setAlertObject] = useState<AlertObject>(null);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const rejectedRef = useRef(false);

  function handleClose(sendEmail: boolean) {
    // Restore the default states
    setAlertObject(null);
    setShowConfirmationModal(false);
    props.onClose(sendEmail);
    if (rejectedRef.current) {
      props.reloadApplication?.();
      rejectedRef.current = false;
    }
  }

  function handleRejectModalClose(
    succeeded: boolean,
    _rejectedReason?: string,
    _error?: Error,
    hasRejectionEmailAutomation?: boolean,
  ) {
    if (succeeded) {
      setAlertObject({
        type: AlertType.Success,
        message: (
          <span>
            <b>{props.candidateName}</b> was successfully rejected for the{' '}
            <b>{props.jobName}</b> job!
          </span>
        ),
      });

      props.onSuccess?.(props.applicationId);
      rejectedRef.current = true;
    } else if (succeeded === false) {
      setAlertObject({
        type: AlertType.Danger,
        message: (
          <span>
            <b>{props.candidateName}</b> could not be rejected for the{' '}
            <b>{props.jobName}</b> job
          </span>
        ),
      });
    }

    if (
      succeeded &&
      props.sendEmailEnabled &&
      props.user.hasEmailConnected &&
      !hasRejectionEmailAutomation
    ) {
      setShowConfirmationModal(true);
    } else {
      handleClose(false);
    }
  }

  return (
    <>
      {alertObject && (
        <Alert
          type={alertObject.type}
          autoClearTimeout={3000}
          clearable={true}
          onClose={() => setAlertObject(null)}
        >
          {alertObject.message}
        </Alert>
      )}
      <RejectCandidateStageModal
        applicationId={props.applicationId}
        candidateName={props.candidateName}
        jobName={props.jobName}
        isOpen={props.isOpen}
        showConfirmationModal={showConfirmationModal}
        onReject={handleRejectModalClose}
        onClose={handleClose}
      />
    </>
  );
}
